<p-messages [enableService]="true" [closable]="false"></p-messages>

<div class="pr-2 pl-2">
	<div class="row mt-2">
		<div class="col-sm-12 br-input" [ngClass]="{'danger': erroNome && submetido}">
			<label for="nomeCampo">Nome do concurso (Obrigatório):</label>
			<input
				#elNomeCampo
				id="nomeCampo"
				name="nomeCampo"
				pInputText
				type="text"
				data-cy="campo-texto"
				[(ngModel)]="item.nome"
				maxlength="100"
				minlength="3"
			/>
			<sgp-message-feedback [show]="erroNome" [mensagem]="mensagemErroNome" data-cy="erro-nome-campo"></sgp-message-feedback>
		</div>
	</div>

	<div class="row mt-2">
		<div class="col-sm-12 br-input" [ngClass]="{'danger': erroNome && submetido}">
			<label for="codigoCampo">Código do concurso (Obrigatório):</label>
			<input
				#elCodigoCampo
				id="codigoCampo"
				name="codigoCampo"
				pInputText
				type="text"
				data-cy="campo-texto"
				[(ngModel)]="item.codigo"
				maxlength="10"
				minlength="4"
			/>
			<sgp-message-feedback [show]="erroNome" [mensagem]="mensagemErroNome" data-cy="erro-codigo-campo"></sgp-message-feedback>
		</div>
	</div>

	<div class="row mt-2">
		<div class="col-sm-12 br-checkbox d-inline">
			<input
				id="manter-utiliza-perfil"
				name="manter-utiliza-perfil"
				[(ngModel)]="item.utiliza_perfil"
				type="checkbox"
				aria-label="Habilitar para uso do Perfil Profissiográfico"
			/>
			<label for="manter-utiliza-perfil">Habilitar para uso do Perfil Profissiográfico</label>
		</div>
	</div>

	<div class="row mt-2" *ngIf="item.utiliza_perfil">
		<div class="col-sm-12 br-input" [ngClass]="{'danger': erroNome && submetido}">
			<label for="orientacaoCampo">Orientação para preenchimento do questionário (Obrigatório):</label>
			<textarea
				#elOrientacaoCampo
				id="orientacaoCampo"
				name="orientacaoCampo"
				pInputTextarea
				data-cy="campo-texto"
				[(ngModel)]="item.orientacao"
				maxlength="500"
				minlength="0"
				rows="5"
				cols="50"
			></textarea>
			<sgp-message-feedback [show]="erroNome" [mensagem]="mensagemErroNome" data-cy="erro-nome-campo"></sgp-message-feedback>
		</div>
	</div>

	<div class="row mt-4 mb-4">
		<div class="col-sm-12 text-right">
			<button pButton data-cy="btnCancelar" class="secondary mr-2" (click)="cancelar() ">Cancelar</button>
			<button id="btnSalvar" data-cy="botao-salvar" class="primary" (click)="salvar()" type="submit" pButton>
				Salvar {{tabela}}
			</button>
		</div>
	</div>
</div>
